export default class Player {
	static STATUS_IDLE = 0; // дома
	static STATUS_RETURNING = 1; // возвращается в деревню
	static STATUS_MOVING = 2; // идет в деревню (например атака) (свое название константы)
	static STATUS_UNKNOWN_2 = 3; // (иконки нет)
	static STATUS_ADVENTURE = 4; // идет в приключение (свое название константы)
	static STATUS_SUPPORTING = 5; // (иконка щита)
	static STATUS_UNKNOWN_3 = 6; // (иконка с клеткой)
	static STATUS_DEAD = 7; // герой мертв
	static STATUS_REVIVING = 8; // герой восстанавливается в деревне
	
	static TRIBE_ROMAN = 1;
	static TRIBE_TEUTON = 2
	static TRIBE_GAUL = 3;
	static TRIBE_NATAR = 4;
}